import React from 'react'
import BaseLevel from './base.levels'
import { BaseLevelLayoutComponent, DotsGridComponent } from '../level.components'
import hundredSquareTapUtils from './utils/hundredSquareTap.utils'

export default class HundredSquareTapComponent extends BaseLevel {
    onEnter = () => {
        this.setState({ wrongAnswer: false, answer: '?' })
        this.props.onRoundComplete()
        this.generateLevel()
        this.onRoundComplete()
    }
    onFail = () => {
        this.setState({ wrongAnswer: true, answer: '?' })
        this.props.onRoundFail()
        this.onRoundFail()
    }
    render() {
        const level = this.props.level
        const stage = this.props.stage
        let settings = level.settings
        settings.answer_required = 'answer'
        const quantities = this.state.quantities
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        const gameContainerWidth = this.state.gameContainerWidth
        const gameContainerHeight = this.state.gameContainerHeight
        const showSum = settings.show_sum
        return (
            <BaseLevelLayoutComponent level={level} togglePause={this.props.togglePause} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} stage={stage} answer={answer} wrongAnswer={wrongAnswer} noKeyboard={true} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter}>
                <div ref="level" className='level'>
                    {gameContainerHeight > 0 && hundredSquareTapUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, this.onEnter, this.onFail)}
                </div>
            </BaseLevelLayoutComponent>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/levels/hundredSquareTap.levels.js